// tslint:disable: no-inferrable-types
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { BackendObjectRef } from '../lib/backend-integration.service';
import { State } from '../lib/state.model';

@Component({
    selector: 'eas-workflow-states-list-item',
    templateUrl: './states-list-item.component.html',
    styleUrls: ['./states-list-item.component.css'],
    standalone: false
})
export class WorkflowStatesListItemComponent {

  @Input() availableRoles: BackendObjectRef[] = [];
  @Input() isFirst: boolean = false;
  @Input() isLast: boolean = false;
  @Input() item!: State;

  @Output() editState = new EventEmitter<string>();

  constructor() {}

  //
  // Actions
  //

  public onEdit(): void {
    this.editState.emit(this.item.id);
  }

  //
  // Template helpers
  //

  public hasCanDeleteBookingPermissions(): boolean {
    return this.item.canDeleteRoles.length > 0;
  }

  public canDeleteRolesDescription(): string {
    return this.item.canDeleteRoles.map(role => role.name).join(', ');
  }

}
